import { BehaviorSubject } from "rxjs";

export const APP_INFOS = { app_name: 'coop_finance_backoffice', app_commit_sha: '846f22283121', app_version: '2026.0321.1544' };
export const API_INFOS$ = new BehaviorSubject({ app_name: '', app_commit_sha: '846f22283121', app_version: '2026.0321.1544' });